// ============================================================
// DateTimeRow.tsx — a "date + time" pair that can never overlap.
//
// The three-box DateInput has a fixed natural width (~236px). Dropped into a
// two-column grid (Tailwind's grid-cols-2 = minmax(0, 1fr) tracks) next to a
// time input, a narrow column let the date overflow into the time field's
// cell. Here the pair is a wrapping flex row instead: the date keeps its
// natural width (capped at the row so it can't overflow), the time takes the
// rest — side by side when there's room, the time wraps under the date when
// there isn't. Spacing matches the info-form grid (FGRID).
// ============================================================
import React from 'react'

interface DateTimeRowProps {
  date: React.ReactNode
  time: React.ReactNode
  className?: string
}

const DateTimeRow: React.FC<DateTimeRowProps> = ({ date, time, className }) => (
  <div className={`flex flex-wrap items-start gap-x-[14px] gap-y-3 ${className ?? ''}`}>
    <div className="flex-none max-w-full min-w-0">{date}</div>
    <div className="flex-1 basis-36 min-w-[min(9rem,100%)]">{time}</div>
  </div>
)

export default DateTimeRow
